import { render, staticRenderFns } from "./MedicalStudentManagement.vue?vue&type=template&id=44e8d1f6&scoped=true"
import script from "./MedicalStudentManagement.vue?vue&type=script&lang=js"
export * from "./MedicalStudentManagement.vue?vue&type=script&lang=js"
import style0 from "./MedicalStudentManagement.vue?vue&type=style&index=0&id=44e8d1f6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44e8d1f6",
  null
  
)

export default component.exports